export interface PostMeta {
  author: string;
  description: string;
  /** @deprecated Use publishedDate instead */
  year?: string;
  /** ISO 8601 date string (e.g., '2025-01-15') */
  publishedDate: string;
  /** ISO 8601 date string. If not provided, publishedDate is used for lastmod */
  updatedDate?: string;
  /** SEO keywords for meta tag */
  keywords?: string[];
}

export interface BlogPost {
  category: string;
  categorySlug: string;
  title: string;
  meta: PostMeta;
  content: string;
}

export type BlogPosts = Record<string, BlogPost>;

/**
 * Get the last modified date for a blog post.
 * Returns updatedDate if available, otherwise publishedDate.
 * Falls back to year field for legacy posts.
 */
export function getLastModifiedDate(meta: PostMeta): Date {
  if (meta.updatedDate) {
    return new Date(meta.updatedDate);
  }
  if (meta.publishedDate) {
    return new Date(meta.publishedDate);
  }
  // Legacy fallback for posts with only year
  if (meta.year) {
    return new Date(`${meta.year}-01-01`);
  }
  return new Date();
}

/**
 * Check if a blog post should be published (publishedDate <= today)
 * 한국 시간(KST) 기준으로 비교 (배포 서버 UTC 시 타임존 이슈 방지)
 */
export function isPublished(meta: PostMeta): boolean {
  if (!meta.publishedDate) {
    return true; // Legacy posts without publishedDate are always published
  }
  const publishDateStr = meta.publishedDate.slice(0, 10); // YYYY-MM-DD
  const todayStr = new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Seoul' }); // YYYY-MM-DD
  return publishDateStr <= todayStr;
}
